module.exports = __webpack_public_path__ + "img/thumbs.e8036ac0.svg";